import React from 'react';
import PropTypes from 'prop-types';
import {fromJS} from 'immutable';
import FlatBarChart from 'generic/FlatBarChart/FlatBarChart.react';
import {stats} from 'lib/StatsUtil';

import './assignment-completion-status.scss';

//XXX: Probably see if we can pull the tooltip out of the FlatBarChart impl
export default class AssignmentCompletionStatus extends React.PureComponent {
  static propTypes = {
    numberSubmitted: PropTypes.number.isRequired,
    numberSubmittedLate: PropTypes.number.isRequired,
    numberNotSubmitted: PropTypes.number.isRequired,
    inline: PropTypes.bool,
    tiny: PropTypes.bool,
    graphDescription: PropTypes.string,
    tooltipText: PropTypes.string
  };

  getData() {
    const {numberSubmitted, numberSubmittedLate, numberNotSubmitted} = this.props;
    const total = numberSubmitted + numberSubmittedLate + numberNotSubmitted;
    return fromJS([
      {
        fillColorClass: 'status-graph-submitted',
        fillPercentage: stats.percentage(this.props.numberSubmitted, total),
        keyLabel: 'Submitted'
      },
      {
        fillColorClass: 'status-graph-submitted-late',
        fillPercentage: stats.percentage(this.props.numberSubmittedLate, total),
        keyLabel: 'Submitted Late'
      },
      {
        fillColorClass: 'status-graph-not-submitted',
        fillPercentage: stats.percentage(this.props.numberNotSubmitted, total),
        keyLabel: 'Not Submitted'
      }
    ]);
  }

  render() {
    return (
      <FlatBarChart
        inline={this.props.inline}
        tiny={this.props.tiny}
        tooltipText={this.props.tooltipText}
        graphDescription={this.props.graphDescription}
        data={this.getData()}
      />
    );
  }
}
